import { Box, Stack } from '@mui/material';
import { Card, DetailRow, CustomSkeleton } from './styles';

export const ComponentCardSkeleton = () => {
  return (
    <Card>
      <DetailRow>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <CustomSkeleton
            variant="rectangular"
            animation="wave"
            width={18}
            height={18}
            sx={{ mr: 1 }}
          />
          <CustomSkeleton variant="text" animation="wave" width={70} height={16} />
        </Box>
        <CustomSkeleton variant="text" animation="wave" width={50} height={20} />
      </DetailRow>
      <DetailRow>
        <CustomSkeleton variant="text" animation="wave" width={100} height={14} />
        <CustomSkeleton variant="text" animation="wave" width={110} height={14} />
      </DetailRow>
    </Card>
  );
};

export const ComponentCardListSkeleton = ({ count = 5 }: { count?: number }) => {
  return (
    <Stack width="100%" gap="0.2rem" height="100%">
      {Array.from({ length: count }, (_, index) => (
        <ComponentCardSkeleton key={index} />
      ))}
    </Stack>
  );
};
